import {
  LoginRequestSchema,
  LoginResponseSchema,
  type LoginRequest,
} from "@/lib/schemas/auth";
import { parseOrThrow } from "@/lib/schemas/utils";
import api from "@/lib/axios";
import { AxiosError } from "axios";

export async function loginUser(data: LoginRequest) {
  const validatedRequest = LoginRequestSchema.parse(data);

  try {
    const response = await api
      .getAxiosInstance()
      .post("/accounts/login/", validatedRequest);

    const resData = response.data;

    // Handle legacy user responses (customCode 201, 202, 203)
    if (resData?.customCode && ["201", "202", "203"].includes(resData.customCode)) {
      return resData;
    }

    if (response.status === 200 && resData?.success === true) {
      // Store tokens in localStorage (replaces HttpOnly cookie approach)
      if (resData.access_token) {
        localStorage.setItem("access_token", resData.access_token);
      }
      if (resData.refresh_token) {
        localStorage.setItem("refresh_token", resData.refresh_token);
      }
      if (resData.user) {
        localStorage.setItem("user", JSON.stringify(resData.user));
      }

      const validated = parseOrThrow(LoginResponseSchema, resData, "loginUser");
      return validated;
    }

    throw new Error(resData?.message || "Login failed");
  } catch (error: unknown) {
    if (error instanceof AxiosError) {
      if (
        error.response?.data &&
        typeof error.response.data === "object" &&
        "message" in error.response.data
      ) {
        throw new Error(error.response.data.message as string);
      }
      if (error.response?.status === 401) {
        throw new Error("Invalid credentials. Please check your username/email and password.");
      }
    }
    throw new Error((error as Error).message || "Login failed");
  }
}

export async function logoutUser() {
  try {
    await api.post("/accounts/logout/");
  } catch (error: unknown) {
    console.error("Backend logout call failed:", error);
  }
  // Always clear local state
  localStorage.removeItem("access_token");
  localStorage.removeItem("refresh_token");
  localStorage.removeItem("user");
  localStorage.removeItem("user_roles");
  return { success: true, message: "Logged out successfully" };
}
